import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultCrmIdsDataSelector,
    userSearchResultCrmIdsResultSelector,
} from '../../slices/user-search-result-crm-ids.slice';

type Props = {
    userId: number,
};

export const DealCloudIdCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultCrmIdsDataSelector);
    const result = useSelector(userSearchResultCrmIdsResultSelector);

    const dealCloudId = useMemo(
        () => result?.data[userId]?.dealCloudId,
        [result, userId],
    );

    if (isLoading || loadingError || !dealCloudId) {
        return null;
    }

    return (
        <EllipsisTextHint title={dealCloudId}>{dealCloudId}</EllipsisTextHint>
    );
};
